var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMyArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mypage / Book_Open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 10.1392V20.3392M12 10.1392C12 8.459 12 7.61927 12.327 6.97754C12.6146 6.41305 13.0732 5.95396 13.6377 5.66634C14.2794 5.33936 15.1196 5.33936 16.7998 5.33936H19.3998C19.9599 5.33936 20.2401 5.33936 20.454 5.44835C20.6422 5.54422 20.7948 5.69709 20.8906 5.88525C20.9996 6.09917 21 6.3794 21 6.93945V15.7395C21 16.2995 20.9996 16.5791 20.8906 16.7931C20.7948 16.9812 20.6425 17.1346 20.4543 17.2305C20.2406 17.3394 19.961 17.3394 19.402 17.3394H16.5693C15.6301 17.3394 15.1597 17.3394 14.7334 17.4688C14.356 17.5834 14.0057 17.7711 13.701 18.0215C13.3568 18.3044 13.096 18.6951 12.575 19.4766L12 20.3392M12 10.1392C12 8.459 11.9998 7.61927 11.6729 6.97754C11.3852 6.41305 10.9263 5.95396 10.3618 5.66634C9.72004 5.33936 8.87977 5.33936 7.19961 5.33936H4.59961C4.03956 5.33936 3.75981 5.33936 3.5459 5.44835C3.35774 5.54422 3.20487 5.69709 3.10899 5.88525C3 6.09917 3 6.3794 3 6.93945V15.7395C3 16.2995 3 16.5791 3.10899 16.7931C3.20487 16.9812 3.35774 17.1346 3.5459 17.2305C3.7596 17.3394 4.03901 17.3394 4.59797 17.3394H7.43073C8.36994 17.3394 8.83942 17.3394 9.26569 17.4688C9.64306 17.5834 9.99512 17.7711 10.2998 18.0215C10.6426 18.3032 10.9017 18.6919 11.4185 19.4671L12 20.3392",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMyArchive);
export default __webpack_public_path__ + "static/media/ic_my_archive.32f886561a0cdb2bfbe3b96f922d5ab6.svg";
export { ForwardRef as ReactComponent };